import {Translate} from "./Translate";
import {getStore} from "trim-redux";

export const TablePage = 10;
export const TableCount = [10,20,50,100,200];
export const TableCountForCat = [3,5,10];

export const RWN = () => {
    let features = getStore('features');
    let rwn = {
        admin: Translate.admin,
        support: Translate.supportUser,
        accountant: Translate.accountant,
        marketer: Translate.marketer,
        user: Translate.user,
    };
    if(!!features.marketplace){
        rwn['supplier'] = Translate.supplier
    }
    if(!!features.agent){
        rwn['agent'] = Translate.agent
    }
    return rwn;
};

export const rolesWithName = () => {
    let features = getStore('features');
    let rwn = [
        {
            value: "admin",
            type: "admin",
            name : Translate.admin
        },
        {
            value: "support",
            type: "admin",
            name : Translate.supportUser
        },
        {
            value: "accountant",
            type: "admin",
            name : Translate.accountant
        },
        {
            value: "marketer",
            type: "normal",
            name : Translate.marketer
        },
        {
            value: "user",
            type: "normal",
            name : Translate.user
        },
    ];
    if(!!features.marketplace){
        rwn.push(
            {
                value: "supplier",
                type: "normal",
                name : Translate.supplier
            }
        )

    }
    if(!!features.agent){
        rwn.push(
            {
                value: "agent",
                type: "normal",
                name : Translate.agent
            }
        )

    }
    return rwn;
};
export const typesWithName = [
    {
        value: "admin",
        name : Translate.adminType
    },
    {
        value: "normal",
        name : Translate.normalType
    },
];

export const shopTypesWithName = [
    {
        value: "publisher",
        name : Translate.publisherShop,
        description: Translate.publisherShopDesc
    },
    {
        value: "distribution",
        name : Translate.distributionShop,
        description: Translate.distributionShopDesc
    },
    {
        value: "virtual_store",
        name : Translate.virtual_storeShop,
        description: Translate.virtual_storeShopDesc
    },
    {
        value: "physical_store",
        name : Translate.physical_storeShop,
        description: Translate.physical_storeShopDesc
    },
    {
        value: "normal",
        name : Translate.normalShop,
        description: Translate.normalShopDesc
    },
];
export function isAdmin(){
    let user = getStore('user');
    try {
        if(user.role.type === "admin"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}